import React, { useState, useEffect } from "react";
import { graphql, navigate } from "gatsby";
import Layout from '../components/layout';
import TitleLarge from "../components/title-large-content";
import BrandsFilterList from "../components/brands-filter";
import { Helmet } from "react-helmet";
import ReactPaginate from "react-paginate";
import prevNextPaginationButtons from "../helper/prevNextPaginationButtons";

export default ({ data, pageContext }) => {
    const {
        customFields,
        brands,
        brandIndustries,
        brandRegions
    } = data;

    const filterList = { brandIndustries, brandRegions };
    const { brandsCustomFields, seo, additionalMetaTag, title } = customFields;
    const { brandLargeContent } = brandsCustomFields;
    // Set metadata
    const seoData = { ...{ seo }, additionalMetaTag, title };
    //Pagination
    const prevButton = 'case-studies-previous';
    const nextButton = 'case-studies-next';
    const keyPagination = process.env.KEY_PAGINATION_PORTFOLIO;
    const [paginateButtons, setPaginateButtons] = useState(false);
    useEffect(() => {
        const prevButtonEl = document.getElementsByClassName(prevButton);
        const nextButtonEl = document.getElementsByClassName(nextButton);
        const paginateButtonsEl = { prevButtonEl, nextButtonEl };
        setPaginateButtons(paginateButtonsEl);
    }, [prevButton, nextButton]);

// 'dark-background' there is option for dark background

    return (
        <Layout
            seoData={seoData}>
            <Helmet
                bodyAttributes={{
                    class: 'dark-background'
                }}
            />
            <div className={'page-content post-type-archive-portfolio inner-pages'}>
                <TitleLarge
                    data={brandLargeContent}/>
                <BrandsFilterList
                    filterList={filterList}
                    data={brands}/>

                {pageContext && pageContext.totalPages > 1 && (
                    <div className={'pagination-wrapper'}>
                        <ReactPaginate
                            previousClassName={prevButton}
                            nextClassName={nextButton}
                            previousLabel={
                                pageContext?.page !== 1 && <span className={'pager-arrow arrow-left'}/>
                            }
                            nextLabel={
                                pageContext?.totalPages !== pageContext.page && (
                                    <span className={'pager-arrow arrow-right'}/>
                                )
                            }
                            onPageChange={({ selected }) => {
                                const page = selected + 1
                                const path = page === 1 ? `/${keyPagination}/` : `/${keyPagination}/${page}/`
                                navigate(path)
                            }}
                            disableInitialCallback
                            breakLabel={"..."}
                            breakClassName={"break-me"}
                            pageCount={pageContext.totalPages}
                            marginPagesDisplayed={1}
                            pageRangeDisplayed={2}
                            containerClassName={"pager blog-pager flex-justify-sb pager-list flex-container"}
                            subContainerClassName={"pages pagination"}
                            activeClassName={"active"}
                            initialPage={pageContext.page - 1}
                            pageClassName={"pager-item flex-center"}
                            hrefBuilder={(page) => {
                                prevNextPaginationButtons(paginateButtons);
                                return `/${keyPagination}/${page}/`;
                            }}
                        />
                    </div>
                )}
            </div>
        </Layout>
    )
}

export const query = graphql`
    query PortfolioQuery($offset: Int!, $perPage: Int!) {
        customFields: wpPage(slug: {eq: "portfolio"}) {
            title
            brandsCustomFields {
                brandLargeContent {
                    button
                    fieldGroupName
                    title
                    link {
                        fieldGroupName
                        text
                        url
                    }
                    backgroundColor
                    textColor
                    buttonSize
                }
            }
            seo {
                title
                metaDesc
                canonical
            }
            additionalMetaTag {
                keywords
                ogDescription
                ogTitle
                ogType
                ogImage {
                    mediaItemUrl
                }
                twitterImage{
                    mediaItemUrl
                }
                twitterTitle
                twitterDescription
            }
        }

        brands: allWpPortfolio(
            limit: $perPage
            skip: $offset
            filter: {nodeType: {in: "Portfolio"},
                brandsItemsCustomFields: {visibleAtBrandsPage: {in: "Yes"}}}
        ) {
            nodes {
                projectInfo {
                    projectUrl
                }
                id
                slug
                title
                brandsItemsCustomFields {
                    brandName
                    shortDescription
                    caseStudy {
                        text
                        post {
                            ... on WpCaseStudy {
                                id
                                uri
                            }
                        }
                    }
                }
                featuredImage {
                    node {
                        sourceUrl
                        remoteFile {
                            childImageSharp {
                                fluid(quality: 70) {
                                    ...GatsbyImageSharpFluid
                                }
                            }
                        }
                    }
                }
                portfolioIndustries {
                    nodes {
                        id
                        name
                    }
                }
                portfolioRegions {
                    nodes {
                        id
                        name
                    }
                }
                tags {
                    nodes {
                        id
                        name
                    }
                }
            }
        }

        brandIndustries: allWpPortfolioIndustry {
            nodes {
                id
                name
                nodeType
                slug
            }
        }

        brandRegions: allWpPortfolioRegion {
            nodes {
                id
                name
                nodeType
                slug
            }
        }
    }`